import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ImageLoader from "../../../components/ImageLoader";

const useStyles = makeStyles(theme => ({
  header: {
    height: "64px",
    padding: theme.spacing(4),
    position: "sticky",
    top: 0,
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    zIndex: 10
  },
  avatar: {
    width: "35px",
    height: "35px",
    borderRadius: "30px",
    overflow: "hidden",

    "& img": {
      width: "100%",
      objectFit: "contain"
    }
  },
  storeName: {
    marginLeft: theme.spacing(2),
    marginBottom: 0,
    fontWeight: 500,
    fontSize: "1.25rem"
  },
  grow: {
    flexGrow: 1
  },
  searchbox: {
    width: "300px",
    position: "relative",
    border: "1px solid",
    borderColor: theme.palette.divider,
    borderRadius: "30px"
  },
  searchInput: {
    width: "270px",
    height: "32px",
    padding: "0.25rem 1rem",
    background: "none",
    border: "none",
    outline: "none"
  },
  searchIcon: {
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: theme.palette.divider,
    border: "none",
    borderRadius: "30px"
  }
}));

const Header = ({ store, onSearchChange }) => {
  const classes = useStyles();

  return (
    <header className={classes.header}>
      {store.logo ? (
        <ImageLoader imgKey={store.logo.key} className={classes.avatar} circularProgressSize={20} />
      ) : (
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/avatar.png`}
          className={classes.avatar}
          alt="Logo"
        />
      )}
      <h1 className={classes.storeName}>{store.name}</h1>
      <div className={classes.grow}></div>
      <div className={classes.searchbox}>
        <input
          className={classes.searchInput}
          type="search"
          placeholder="Búsqueda"
          onChange={({ target }) => onSearchChange(target.value)}
        />
        <div className={classes.searchIcon}>
          <i className="fa fa-search"></i>
        </div>
      </div>
    </header>
  );
};

export default Header;
